import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AddressAutocompleteComponent } from '../../../ui-components/address-autocomplete/address-autocomplete.component';
import { ParameterService } from '../../../shared/services/parameter/parameter.service';
import { Option } from '../../../ui-components/core-dropdown/core-dropdown.component';
import { AppAlertService } from '../../../shared/services/app-alert/app-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { ServicePricePopupComponent } from '../../../shared/components/service-price-popup/service-price-popup.component';
import { IServicePriceItems } from '../../../shared/services/services/services/services.service';
import { RegionDistrictService } from '../../definition/region/service/region-district.service';
import { PriceInfoService } from '../services/price-info.service';
import { CoreOffcanvasComponent } from '../../../ui-components/core-offcanvas/core-offcanvas.component';
import { AppMessageService } from '../../../shared/services/app-message/app-message.service';
import { ICreatePriceInfoDto, IUpdatePriceInfoDto } from '../interfaces';
import { Router } from '@angular/router';
import { PatientCreateComponent } from '../../definition/patient/patient-create/patient-create.component';
import { PatientCardComponent } from '../../../shared/components/patient-card/patient-card.component';

@Component({
  selector: 'app-create-price-info',
  templateUrl: './create-price-info.component.html',
  styleUrl: './create-price-info.component.scss',
  providers: [],
})
export class CreatePriceInfoComponent implements OnInit {
  filterForm: FormGroup;
  addressForm: FormGroup;
  priceTypes: Option[] = [];
  caseTypes: any[] = [];
  @ViewChild('fromAddressComponent')
  fromAddressComponent: AddressAutocompleteComponent;
  @ViewChild('toAddressComponent')
  toAddressComponent: AddressAutocompleteComponent;
  @ViewChild('servicePopup') servicePopup: ServicePricePopupComponent;
  @ViewChild('createPriceInfoCanvas') canvas: CoreOffcanvasComponent;
  @Output() saveOn = new EventEmitter<any>();
  @Output() updateOn = new EventEmitter<any>();

  agentNote: string = '';
  agentPhone: string = '';
  priceToSendPatient: any = 0;
  priceList: number | null = null;
  totalPrice: number = 0;
  isSubmit: boolean = false;
  description: string | null = null;
  regionNumber: number | null = null;
  isBrigdePass: boolean | null = null;
  loading: boolean = false;
  priceInfoShowAddress: boolean = false;

  services: IServicePriceItems[] = [];
  header: string = '';
  updatedId: number | null = null;
  isBecomeCase: boolean = false;
  caseId: number | null = null;
  caseNo: string | null;
  initialFilterForm = {
    date: new Date(),
    caseType: null,
    priceType: null,
    services: [],
  };

  
  lockInput: boolean = false;
  showDialog: boolean = false;
  @ViewChild('createPatient') createForm: PatientCreateComponent;
  @ViewChild('patientCard') patientCard: PatientCardComponent;

  personNo: number | null = null;
  personFullName: string = '';

  showSuccessDialog = false;

  showNotification: boolean = false;
// caseNo: string | null = null;
caseTypeCode: string | null = null
  constructor(
    private readonly fb: FormBuilder,
    private readonly regionDistrict: RegionDistrictService,
    private readonly parameterService: ParameterService,
    private readonly appAlertService: AppAlertService,
    private readonly translate: TranslateService,
    private readonly service: PriceInfoService,
    private readonly messageService: AppMessageService,
    private readonly router: Router
  ) {
    this.filterForm = this.fb.group({
      date: new FormControl(new Date(), [Validators.required]),
      caseType: [null, Validators.required],
      priceType: [null, Validators.required],
      services: [[], Validators.required],
    });
    this.addressForm = this.fb.group({
      fromAddress: new FormControl(null, Validators.required),
      toAddress: new FormControl(null, Validators.required),
    });
  }
  ngOnInit(): void {
    this.parameterService
      .getValues('data-group', 'price-types')
      .subscribe((response) => {
        this.priceTypes = response.datas.values.map((data: any) => {
          return {
            label: data.valueObject.name.value,
            value: data?.valueObject?.id?.value,
          };
        });
      });

    this.parameterService
      .getValues('data-group', 'caseTypes')
      .subscribe((response) => {
        this.caseTypes = response.datas.values.map((data: any) => {
          return {
            label: data.valueObject.name.value,
            value: data.id,
            priceInfoShowAddress:
              data?.valueObject?.priceInfoShowAddress?.value,
          };
        });
      });
  }

  handleSetFromAddress(address: any) {
    this.addressForm.patchValue({ fromAddress: address });
    if (this.addressForm) {
      if (
        this.addressForm.value?.toAddress?.city?.length > 0 &&
        this.addressForm.value?.toAddress?.district?.length > 0 &&
        address?.city?.length > 0 &&
        address?.district?.length > 0
      ) {
        this.clearAddressDetail();
        this.regionDistrict
          .calculateRegionBetweenTwoDistricts({
            fromCity: address?.city,
            fromDistrict: address?.district,
            toCity: this.addressForm.value?.toAddress?.city,
            toDisctrict: this.addressForm.value?.toAddress?.district,
          })
          .subscribe({
            next: (res) => {
              if (res) {
                if (res?.description) {
                  this.description = res?.description;
                }

                if (res?.regionNumber) {
                  this.regionNumber = res?.regionNumber;
                }

                this.isBrigdePass = res?.isBrigdePass;
              }
              this.loading = false;
            },
            error: (err) => {
              this.loading = false;
            },
          });
      }
      this.addressForm.patchValue({ fromAddress: address });
    }
  }
  handleSetToAddress(address: any) {
    this.addressForm.patchValue({ toAddress: address });
    if (this.addressForm) {
      // eğer alınan adres ve bırakılan adreslerin il ve ilçeleri boş değil ise,bölge,bölge açıklaması hesaplama servisine istek atılacak.
      if (
        this.addressForm.value?.fromAddress?.city?.length > 0 &&
        this.addressForm.value?.fromAddress?.district?.length > 0 &&
        address?.city?.length > 0 &&
        address?.district?.length > 0
      ) {
        this.clearAddressDetail();
        this.loading = true;
        this.regionDistrict
          .calculateRegionBetweenTwoDistricts({
            fromCity: this.addressForm.value?.fromAddress?.city,
            fromDistrict: this.addressForm.value?.fromAddress?.district,
            toCity: address?.city,
            toDisctrict: address?.district,
          })
          .subscribe({
            next: (res) => {
              if (res) {
                if (res?.description) {
                  this.description = res?.description;
                }

                if (res?.regionNumber) {
                  this.regionNumber = res?.regionNumber;
                }

                this.isBrigdePass = res?.isBrigdePass;
              }
              this.loading = false;
            },
            error: (err) => {
              this.loading = false;
            },
          });
      }
      this.addressForm.patchValue({ toAddress: address });
    }
  }

  openAddressModal(address: 'from' | 'to') {
    if (address === 'from') {
      this.fromAddressComponent.openDialog(this.addressForm.value.fromAddress);
    }
    if (address === 'to') {
      this.toAddressComponent.openDialog(this.addressForm.value.toAddress);
    }
  }

  addService() {
    this.servicePopup.initilize();
  }

  deleteConfirm(item: any) {
    if (item) {
      this.appAlertService.sweetConfirm({
        header: `${item?.serviceName}`,
        message: `${this.translate.instant(
          'price-info.delete-service-confirm-message'
        )} ${item?.serviceName}?`,
        showCloseButton: true, 
        accept: () => this.onDeleteService(item),
        reject: () => {},
      });
    }
  }

  onDeleteService(service: any) {
    this.services = this.services.filter(
      (s) => s?.serviceId !== service?.serviceId
    );
    this.filterForm.get('services')?.setValue(this.services);
  }

  get calculateTotalPrice(): number | string {
    let totalPrice = 0;
    this.filterForm?.value?.services?.map((s: any) => {
      if (s?.total) {
        totalPrice += Number(s?.total);
      }
    });
    return totalPrice;
  }

  onSaveServices(response: {
    services: IServicePriceItems[];
    totalPrice: number;
    numberOfService: number;
  }) {
    response.services = response.services?.filter((s) => s.total != null);
    this.services = [...response.services, ...this.filterForm.value.services];
    this.filterForm
      .get('services')
      ?.setValue([...response.services, ...this.filterForm.value.services]);
    this.totalPrice = response?.totalPrice;
  }

  clearAddressDetail() {
    this.description = null;
    this.isBrigdePass = null;
    this.regionNumber = null;
  }

  onCaseTypeSelected(event: any) {
    const selectedCase = this.caseTypes.find((c) => c.value === event);
    if (selectedCase?.priceInfoShowAddress) {
      this.priceInfoShowAddress = true;
    } else {
      this.priceInfoShowAddress = false;
    }

    this.addressForm.reset();
    this.regionNumber = null;
    this.description = null;
    this.isBrigdePass = null;
  }
  onlyAllowNumbers(event: any) {
    // Girilen tüm harfleri ve istenmeyen karakterleri temizle
    let input = event.target.value.replaceAll(/\D/g, ''); // \D: rakam olmayan her şey
    event.target.value = input;
    this.agentPhone = input;
  }

  onOffCanvasClosed() {
    this.addressForm.reset();
    this.filterForm.patchValue({ ...this.initialFilterForm });
    this.clearStates();
  }

  openOffCanvas() {
    this.canvas.openPopup();
  }
  closeCanvas() {
    this.canvas.closePopup();
  }

  initilize(data?: any) {
    if (data) {
      this.header = data?.id ? ` | ${data?.id} - ${data?.description}` : '';
      this.updatedId = data?.id;
      this.filterForm.patchValue({
        caseType: data?.caseType?.id || data?.caseType,
        priceType: data?.priceType?.id || data?.priceType,
        date: new Date(data?.date),
      });
      this.addressForm.patchValue({
        fromAddress: data?.fromAddress,
        toAddress: data?.toAddress,
      });

      this.agentPhone = data?.phone;
      this.agentNote = data?.description;
      this.priceToSendPatient = data?.priceToSendPatient;
      this.regionNumber = data?.addressRegionNumber;
      this.description = data.addressDescription;
      this.isBrigdePass = data.addressIsBridgePass;
      this.isBecomeCase = data?.isBecomeCase;
      this.caseId = data?.cases?.id ?? null;
      this.caseNo = data?.cases?.caseNo ?? null;
      if (data?.personNo && this.patientCard) {
        this.patientCard.setPatientValue(data.personNo);
      }
      this.personFullName = data?.personFullName ?? null;
      if (data?.services?.length > 0) {
        this.services = data?.services?.map((s: any) => ({
          ...s,
        }));
        this.filterForm.patchValue({ services: this.services });
      }
      if (data?.caseType?.valueObject?.priceInfoShowAddress?.value) {
        this.priceInfoShowAddress = true;
      }
    } else {
      this.updatedId = null;
      this.isBecomeCase = false;
      this.caseId = null;
      this.caseNo = null;
      this.header = '';
    }

    this.openOffCanvas();
  }

  cancelRequest() {
    this.canvas.closePopup();
  }
closeAll() {
  this.showSuccessDialog = false;   // Success dialog kapanır
  this.canvas.closePopup();         // Ana popup kapanır
  this.clearStates();               // Temizlik

  // SweetConfirm kapatma — eğer servisinde close metodu varsa bu çalışır
  if (this.appAlertService.close) {
    this.appAlertService.close();
  }
}

  saveRequestForCase() {
    if (this.updatedId) {
      this.appAlertService.sweetConfirm({
        header: this.translate.instant('price-info.sure-header-to-case'),
        message: this.translate.instant('price-info.sure-text-to-case'),
        showCloseButton: true, 
        accept: () => {
          this.service.becomeCase(this.updatedId!).subscribe({
            next: (res) => {
              this.updateOn.emit(res.data);

              if (res.errorMessages.length === 0) {

                this.caseNo = res.data.cases.caseNo;
                this.caseTypeCode = res.data.caseType.valueObject.code.value;

                this.showSuccessDialog = true;

              } else {
                this.messageService.warningToast('', res.errorMessages.join(','));
              }
            }
          });
        },
        reject: () => { }
      });
    }
  }

  save() {
    this.isSubmit = true;

    // Mark all controls as touched to show validation errors
    this.filterForm.markAllAsTouched();
    if (this.filterForm.invalid) return;
    if (this.priceInfoShowAddress) {
      this.addressForm.markAllAsTouched();
      if (this.addressForm.invalid) return;
    }

    const services = this?.filterForm?.value?.services.map((s: any) => ({
      serviceId: s?.serviceId || null,
      serviceCode: s?.serviceCode || null,
      serviceName: s?.serviceName || null,
      quantity: s?.quantity || null,
      gatePrice: s?.gatePrice || null,
      memberPrice: s?.memberPrice || null,
      total: s?.total || null,
      priceType: s?.priceType,
      unitPrice: s?.unitPrice,
    }));
    let data: ICreatePriceInfoDto = {
      caseType: this.filterForm.value.caseType,
      priceType: this.filterForm.value.priceType,
      date: new Date(this.filterForm.value.date),
      description: this.agentNote,
      phone: this.agentPhone,
      priceToSendPatient: this.priceToSendPatient,
      fromAddress: null,
      toAddress: null,
      services: services,
      addressRegionNumber: null,
      addressDescription: null,
      addressIsBridgePass: null,

      personNo: this.personNo ?? null,
      personFullName: this.personFullName ?? null,
    };

    if (this.priceInfoShowAddress) {
      data.fromAddress = this.addressForm.value.fromAddress;
      data.toAddress = this.addressForm.value.toAddress;
      data.addressRegionNumber = this.regionNumber;
      data.addressDescription = this.description;
      data.addressIsBridgePass = this.isBrigdePass;
    }

    this.service.create(data).subscribe((res) => {
      this.messageService.successToast(
        this.translate.instant('common.success'),
        this.translate.instant('common.saveSuccessToastMessage')
      );
      this.saveOn.emit(res);
      this.canvas.closePopup();
      this.clearStates();
    });
  }

  update() {
    this.isSubmit = true;

    // Mark all controls as touched to show validation errors
    this.filterForm.markAllAsTouched();
    if (this.filterForm.invalid) return;
    if (this.priceInfoShowAddress) {
      this.addressForm.markAllAsTouched();
      if (this.addressForm.invalid) return;
    }

    const services = this.services.map((s) => ({
      serviceId: s?.serviceId || null,
      serviceCode: s?.serviceCode || null,
      serviceName: s?.serviceName || null,
      quantity: s?.quantity || null,
      gatePrice: s?.gatePrice || null,
      memberPrice: s?.memberPrice || null,
      total: s?.total || null,
      priceType: s?.priceType,
      unitPrice: s?.unitPrice,
    }));
    let data: IUpdatePriceInfoDto = {
      id: this.updatedId,
      caseType: this.filterForm.value.caseType,
      priceType: this.filterForm.value.priceType,
      date: new Date(this.filterForm.value.date),
      description: this.agentNote,
      phone: this.agentPhone,
      priceToSendPatient: this.priceToSendPatient,
      fromAddress: null,
      toAddress: null,
      services: services,
      
      personNo: this.personNo ?? null,
      personFullName: this.personFullName ?? null,
    };

    if (this.priceInfoShowAddress) {
      data.fromAddress = this.addressForm.value.fromAddress;
      data.toAddress = this.addressForm.value.toAddress;
      data.addressRegionNumber = this.regionNumber;
      data.addressDescription = this.description;
      data.addressIsBridgePass = this.isBrigdePass;
    }

    this.service.update(data).subscribe((res) => {
      this.messageService.successToast(
        this.translate.instant('common.success'),
        this.translate.instant('common.updateSuccessToastMessage')
      );
      this.updateOn.emit(res);
      this.canvas.closePopup();
      this.clearStates();
    });
  }

  clearStates() {
    this.agentNote = '';
    this.agentPhone = '';
    this.priceInfoShowAddress = false;
    this.priceToSendPatient = 0;
    this.priceList = null;
    this.totalPrice = 0;
    this.isSubmit = false;
    this.description = null;
    this.regionNumber = null;
    this.isBrigdePass = null;
    this.loading = false;
    this.isBecomeCase = false;
    this.priceInfoShowAddress = false;
    this.services = [];

    this.patientCard.resetSelectedPatient();
    this.personFullName = '';
  }

  allowOnlyValidChars(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    const charStr = String.fromCodePoint(charCode);

    // Allow digits (0-9), dot (.), and comma (,)
    if (!charStr.matchAll(/[0-9.,]/)) {
      event.preventDefault();
    }
  }

  formatPrice() {
    let raw = this.priceToSendPatient?.toString().replaceAll(/,/g, '');

    if (!raw || Number.isNaN(+raw)) return;

    // Format using built-in Intl API (or use Angular pipe if needed)
    const formatted = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number.parseFloat(raw));

    this.priceToSendPatient = formatted;
  }

  goCase() {
    if (this.caseId) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/case/${this.caseId}`], {
          queryParams: {
            fullscreen: true,
          },
        })
      );
      window.open(url, '_blank');
    }
  }

  onOpenDetail(patientDetail: any) {
    this.showDialog = true;
    setTimeout(() => {
      this.createForm.initialize(patientDetail);
    }, 500);
  }

  onPatientSelect(patient: any) {
    if (patient === null) {
      this.lockInput = false;
      this.personFullName = '';
      this.personNo = null;
      return;
    }

    if (patient?.firstName && patient?.lastName) {
      this.lockInput = true;
      this.personFullName = `${patient.firstName} ${patient.lastName}`;
      this.personNo = patient.id;
    }
  }

  onStringInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    // Sadece harfleri ve boşluğu kabul et
    inputElement.value = inputElement.value.replaceAll(
      /[^a-zA-ZğüşöçıİĞÜŞÖÇ ]/g,
      ''
    );
  }

  copyText() {
    const textToCopy = `${this.caseTypeCode}-${this.caseNo}`;
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.showNotification = true;
      setTimeout(() => (this.showNotification = false, this.showSuccessDialog = false), 2000);
    });
  }
}
